import { SET_PLAYER, SetPlayerAction } from "./actions"
import { StoreAction } from "../../../types/store"
import { Player } from "../lib/player"
export interface StoreState {
  player: Player | null
}

export const initialState: StoreState = {
  player: null,
}

export default function reducer(state: StoreState, action: StoreAction): StoreState {
  switch (action.type) {
    case SET_PLAYER: {
      const { player } = action as SetPlayerAction
      return {
        ...state,
        player,
      }
    }

    default:
      return state
  }
}
